// extracted by mini-css-extract-plugin
export default {"mainCont":"BioImageItem_mainCont__zhGP-"};